import React from 'react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="py-24 px-6 bg-white" data-id="element-169">
      <div className="max-w-4xl mx-auto text-center" data-id="element-170">
        <FadeIn data-id="element-171">
          <span className="text-coral font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-172">
            Proof / Believability
          </span>
          <h2 className="text-3xl md:text-4xl text-teal mb-12" data-id="element-173">
            What changes in 7 days?
          </h2>

          <div className="grid md:grid-cols-3 gap-6 text-left" data-id="element-174">
            <div className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-175">
              <h4 className="text-2xl font-serif text-teal mb-4" data-id="element-176">By Day 3</h4>
              <p className="text-charcoal/80" data-id="element-177">
                Most women report the "morning puffiness" in their fingers
                subsides.
              </p>
            </div>

            <div className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-178">
              <h4 className="text-2xl font-serif text-teal mb-4" data-id="element-179">By Day 5</h4>
              <p className="text-charcoal/80" data-id="element-180">
                The intensity of nighttime hot flashes typically drops by 50%.
              </p>
            </div>

            <div className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-181">
              <h4 className="text-2xl font-serif text-teal mb-4" data-id="element-182">By Day 7</h4>
              <p className="text-charcoal/80" data-id="element-183">
                You wake up feeling "lighter," with joints that move freely and
                a mind that finally feels rested.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}